// components/ProfitLossCell.jsx
import React from "react";
import { currencyFormat, toFixedWithoutRounding } from "./Constant";

// ---- Pure helpers ----

const isBackLayWin = (item) =>
  (item?.teamSelectionWin == item?.selectionId && item?.betType == "back") ||
  (item?.teamSelectionWin != item?.selectionId && item?.betType == "lay");

const isSportBookWin = (item) =>
  !!item?.teamSelectionWin?.split(",").includes(item?.fancySelectionId);

const isFancyWin = (item) =>
  item?.type == "No"
    ? item?.decisionRun < item?.betRun
    : item?.decisionRun >= item?.betRun;

const resolveWin = (item, getBetType) => {
  if (getBetType === "all") {
    if (item?.runnerName && item?.fancySelectionId) return isSportBookWin(item);
    if (item?.betRun != null && item?.decisionRun != null && !item?.teamName) {
      return isFancyWin(item);
    }
    return isBackLayWin(item);
  }
  if (
    ['exchange'].includes(getBetType)
  ) {
    return isBackLayWin(item);
  }
  if (getBetType === "sportbook") {
    return isSportBookWin(item);
  }
  return isFancyWin(item);
};

// ---- Single component ----

const ProfitLossCell = React.memo(function ProfitLossCell({
  item,
  filter,
  getBetType,
  styleBody,
}) {
  // 1. Parlay bets
  if (getBetType == "parlay") {
    if (!item?.isDeclared) {
      return (
        <td style={styleBody} _ngcontent-serverapp-c119>
          <span _ngcontent-serverapp-c119 id="pol" className="small-date">
            Not Settled
          </span>
        </td>
      );
    }

    const win = item?.result === "win";
    const value = win
      ? Math.abs(toFixedWithoutRounding(item?.profitAmount, 2))
      : `(${Math.abs(toFixedWithoutRounding(item?.loseAmount, 2))})`;

    return (
      <td style={styleBody} _ngcontent-serverapp-c119>
        <span
          _ngcontent-serverapp-c119
          id="pol"
          className={win ? "small-date win-text" : "small-date loss-text"}
        >
          {Math.abs(value)}
        </span>
      </td>
    );
  }

  // 2. Voided bets
  if (item?.status === "voided") {
    return (
      <td style={styleBody} _ngcontent-serverapp-c119>
        <span _ngcontent-serverapp-c119 id="pol" className="small-date">
          0.00
        </span>
      </td>
    );
  }

  const isCasino =
    filter?.type === "casino" ||
    (filter?.type === "all" &&
      !!(item?.casinoBetId || item?.casinoName) &&
      !item?.matchBetId);

  // 3. Non-casino: shared win/loss resolver
  if (!isCasino) {
    const win = resolveWin(item, getBetType);
    const value = win ? item?.profitAmount : `-(${item?.loseAmount})`;

    return (
      <td style={styleBody} _ngcontent-serverapp-c119>
        <span
          _ngcontent-serverapp-c119
          id="pol"
          className={win ? "small-date win-text" : "small-date loss-text"}
        >
          {value ?? "-"}
        </span>
      </td>
    );
  }

  // 4. Casino: betfair / Bookmaker
  if (getBetType === "exchange") {
    const win = isBackLayWin(item);
    const value = win ? item?.profitAmount : `-(${item?.loseAmount})`;

    return (
      <td style={styleBody} className="text-end" _ngcontent-serverapp-c119>
        <span
          _ngcontent-serverapp-c119
          id="pol"
          className={win ? "small-date win-text" : "small-date loss-text"}
        >
          {value ?? "-"}
        </span>
      </td>
    );
  }

  // 4b. Casino: sportBook
  if (getBetType === "sportbook") {
    const win = isSportBookWin(item);
    const value = win ? item?.profitAmount : `-(${item?.loseAmount})`;

    return (
      <td style={styleBody} className="text-end" _ngcontent-serverapp-c119>
        <span
          _ngcontent-serverapp-c119
          id="pol"
          className={win ? "small-date win-text" : "small-date loss-text"}
        >
          {value ?? "-"}
        </span>
      </td>
    );
  }

  // 4c. Casino: fallback -> realCutAmount
  const isLoss = Math.sign(item?.realCutAmount) === -1;
  const amount = isLoss ? item?.realCutAmount : Math.abs(item?.realCutAmount);

  return (
    <td style={styleBody} className="text-end" _ngcontent-serverapp-c119>
      <span
        _ngcontent-serverapp-c119
        id="pol"
        className={isLoss ? "small-date loss-text" : "small-date win-text"}
      >
        ({currencyFormat(amount)})
      </span>
    </td>
  );
});

export default ProfitLossCell;
